import { create } from "zustand";
import type { ScanListItem } from "../types/types";

/**
 * HistoryState is used to save the scan history for a logged in user.
 */
interface HistoryStore {
  scans: ScanListItem[];
  setScans: (scans: ScanListItem[]) => void;
  clearScans: () => void;
}

export const useHistoryStore = create<HistoryStore>((set, _get) => ({
  scans: [],
  setScans: (scans) => {
    set(() => ({
      scans,
    }));
  },
  clearScans: () => {
    set(() => ({
      scans: [],
    }));
  },
}));
